<template>
  <article class="mission-solution mt-3">
    <section class="mission-solution-content">
      <div class="mission-solution-header">
        <h4 class="mission-solution-title">후유와 미션을 함께한 지</h4>
        <div class="d-flex flex-grow-1 justify-end fs-15 fw-500">
          <b v-if="selectedDay === lastMissionDay * 1" class="badge-today error">LAST</b>
          <v-btn :ripple="false"
                 text plain class="pa-0"
                 @click.prevent="onClickMission(missionDays.find(x => Number(x.thday) === activeMissionDay))">
            <b class="badge-today">TODAY</b>
            <b>{{ activeMissionDay }}</b>일차
          </v-btn>
        </div>
      </div>

      <slot name="date">
        <div v-if="missionDays.length > 0" class="mission-date-groups-outer">
          <Flicking ref="flicking" :options="flickingOptions">
            <div v-for="(missions, i) in missionGroup" :key="`group_${i}`"
                 class="mission-date-groups" :class="{ 'full': missions.full }">
              <template v-for="(day, index) in missions.group">
                <span v-if="day === null" class="mission-date-item empty" :key="index" />
                <button v-else
                        :key="index" class="mission-date-item"
                        :class="handleDayClass(day)"
                        @click.prevent="onClickMission(day)">
                  {{ day.thday }}
                </button>
              </template>
            </div>
          </Flicking>
        </div>
      </slot>
    </section>

    <section class="mission-solution-content">
      <div class="mission-solution-header">
        <h4 class="mission-solution-title">{{ selectedDay }}일차 미션</h4>
      </div>
      <div class="solution-list">
        <slot name="solution">
          <template v-for="(solution, index) in todayMissions">
            <div v-ripple :key="index"
                 class="solution-list-item"
                 :class="['solution-list-item--fixed', { 'complete': solution.cmpltYn === 'Y' }]"
                 @click="unitDetail(solution.unitUseNo, solution.freeYn, index, todayIndex, (solution.cmpltYn === 'Y'), solution.inactive)">
              <v-avatar>
                <v-img :src="getImage(helpfulIcon(solution.helpful))" />
              </v-avatar>
              <div class="unit-info">
                <b class="unit-name">
                  <IconLock v-if="solution.inactive"/>
                  {{ solution.unitName }}
                </b>
                <span v-if="solution.unitTypeNm !== '' && solution.unitTypeCnt-1 <= 0" class="unit-type">{{solution.unitTypeName}}</span>
                <span v-else-if="solution.unitTypeNm !== '' && solution.unitTypeCnt-1 > 0" class="unit-type">{{solution.unitTypeName}} + {{solution.unitTypeCnt-1}}</span>
              </div>
            </div>
          </template>
        </slot>
      </div>
    </section>
  </article>
</template>

<script>
import IconLock from '@/components/icons/Lock.vue'
import { mixinRemote } from '@/mixins'

export default {
  name: 'MissionSolutionList',
  components: { IconLock },
  mixins: [ mixinRemote ],
  props: {
    lastMissionDay: { type: Number, default: 0 },
    activeMissionDay: { type: Number, default: 0 },
    missionDays: { type: Array, default: () => [] },
    todayMissions: { type: Array, default: () => [] },
    todayIndex: { type: Number, default: 0 },
    selectedDay: { type: Number, default: 0 }
  },
  data: () => ({
    groupSize: 6,
    activeGroup: 0,
    flickingOptions: {
      includeMargin: true,
      bound: true,
      autoInit: true,
      align: 'prev'
    }
  }),
  computed: {
    missionGroup () {
      let groupSize = this.groupSize
      return this.missionDays.reduce((result, item, index) => {
        const groupIndex = Math.floor(index / groupSize)
        if (!result[groupIndex]) {
          result[groupIndex] = { index: groupIndex, group: [] }
        }
        result[groupIndex].group.push(item)
        return result
      }, []).map(({ index, group }) => {
        // 부족한 만큼 null 채우기
        // while (group.length < groupSize) {
        //   group.push(null)
        // }
        return { index, group, full: group.length === groupSize }
      })
    }
  },
  watch: {
    missionDays: {
      immediate: true,
      handler (nV, oV) {
        if (nV && nV !== oV) {
          let activeGroup = Math.floor((Number(this.selectedDay) -1) / this.groupSize)
          if (this.missionDays.length <= this.groupSize) this.$set(this.flickingOptions, 'bounce', 0)
          else this.$set(this.flickingOptions, 'defaultIndex', activeGroup)
        }
      }
    }
  },
  created () {},
  mounted () {},
  methods: {
    moveToGroup (day) {
      let activeGroup = Math.floor((Number(day) - 1) / this.groupSize)
      this.$refs.flicking?.moveTo(activeGroup)
    },
    onClickMission(day) {
      this.$emit('click-mission', day);
    },
    handleDayClass (val) {
      let dayClass = []
      const day = val.thday * 1
      if (this.activeMissionDay > day) dayClass.push('prev')
      if (this.activeMissionDay === day) dayClass.push('today')
      if (val.inactive) dayClass.push('locked')
      if (val.completed) dayClass.push('completed')
      if (this.selectedDay === day) dayClass.push('selected')
      return dayClass
    },
    helpfulIcon (helpful) {
      let str = helpful.substr(0, 2)
      return 'ic_condition_white_' + str + '.svg'
    }
  }
}
</script>
